module.exports = __webpack_public_path__ + "img/qr-land.ff79711c.webp";